export enum actionTypes {
    UPDATE_HISTORY = 'BONUS_HISTORY:HISTORY:UPDATE',
    UPDATE_STATUS = 'BONUS_HISTORY:STATUS:UPDATE',
    UPDATE_PERIOD = 'BONUS_HISTORY:PERIOD:UPDATE',
    TOGGLE_LOADING = 'BONUS_HISTORY:LOADING:TOGGLE',
    LOAD_NEXT_PAGE = 'BONUS_HISTORY:NEXT_PAGE:LOAD',
    SET_ERROR = 'BONUS_HISTORY:ERROR:SET',
}

export const TRIGGER_TYPES = [
    'signup',
    'deposit',
    'promotioncode',
    'customevent',
    'buybonus',
    'bonuscompletion',
    'campaign',
    'gameplay',
    'manual'
];
